import * as React from 'react'

const Loading = ({ inline }: { inline?: boolean }) => (
    <div className="AppCore__ui__Pulse" style={inline ? {} : { marginTop: 'calc(64px + 30%)' }} />
)

export default Loading
